import styled from 'styled-components';
import { ReactComponent as RawTestSVG } from '../../../../assets/icons/icon_test.svg';

export const IconTest = styled(RawTestSVG)``;
